import { cn } from "@/lib/utils";

interface ResponsiveLayoutProps {
  main: React.ReactNode;
  sidebar?: React.ReactNode;
  sidebarPosition?: "left" | "right";
  sidebarWidth?: string;
  reverseOnMobile?: boolean;
}

export default function ResponsiveLayout({
  main,
  sidebar,
  sidebarPosition = "right",
  sidebarWidth = "w-80",
  reverseOnMobile = false,
}: ResponsiveLayoutProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:gap-6">
      {/* On mobile: show sidebar above main when reverseOnMobile is true */}
      {reverseOnMobile && sidebar && (
        <div className="lg:hidden">{sidebar}</div>
      )}

      {/* Desktop left sidebar */}
      {sidebarPosition === "left" && sidebar && (
        <div className={cn("hidden lg:block lg:flex-shrink-0", sidebarWidth)}>
          {sidebar}
        </div>
      )}

      <div className="min-w-0 flex-1">{main}</div>

      {/* Desktop right sidebar */}
      {sidebarPosition === "right" && sidebar && (
        <div className={cn("hidden lg:block lg:flex-shrink-0", sidebarWidth)}>
          {sidebar}
        </div>
      )}
    </div>
  );
}
